'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { Icon, useHasTouchInput } from '@repo/ui';
import { Info } from '@repo/ui/icons';
import { useState } from 'react';
import { HoverCard, HoverCardContent, HoverCardTrigger, Popover, PopoverContent, PopoverTrigger } from '@/components/common/overlays';
interface InfoHoverCardTriggerProps {
  children: ReactNode;
  maxWidth?: string;
  onOpenChange?: (isOpen: boolean) => void;
}
export const InfoHoverCardTrigger = t0 => {
  const $ = _c(25);
  const {
    children,
    maxWidth,
    onOpenChange
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const hasTouchInput = useHasTouchInput();
  let t1;
  if ($[0] !== onOpenChange) {
    t1 = open => {
      setIsOpen(open);
      onOpenChange?.(open);
    };
    $[0] = onOpenChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleOpenChange = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Icon className="text-secondary-foreground hover:text-foreground" icon={<Info />} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const infoIcon = t2;
  if (hasTouchInput) {
    let t3;
    if ($[3] !== handleOpenChange || $[4] !== isOpen) {
      t3 = <PopoverTrigger asChild={true}><div data-testid="info-hover-card-trigger" onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          handleOpenChange(!isOpen);
        }}>{infoIcon}</div></PopoverTrigger>;
      $[3] = handleOpenChange;
      $[4] = isOpen;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== maxWidth) {
      t4 = {
        padding: 0,
        outline: "none",
        maxWidth
      };
      $[6] = maxWidth;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] !== children || $[9] !== t4) {
      t5 = <PopoverContent side="top" sideOffset={8} style={t4} onClick={_temp}>{children}</PopoverContent>;
      $[8] = children;
      $[9] = t4;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== handleOpenChange || $[12] !== isOpen || $[13] !== t3 || $[14] !== t5) {
      t6 = <Popover open={isOpen} onOpenChange={handleOpenChange}>{t3}{t5}</Popover>;
      $[11] = handleOpenChange;
      $[12] = isOpen;
      $[13] = t3;
      $[14] = t5;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    return t6;
  }
  let t3;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <HoverCardTrigger asChild={true}><div data-testid="info-hover-card-trigger">{infoIcon}</div></HoverCardTrigger>;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== maxWidth) {
    t4 = {
      minWidth: "275px",
      maxWidth
    };
    $[17] = maxWidth;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== children || $[20] !== t4) {
    t5 = <HoverCardContent side="top" sideOffset={8} onClick={_temp2} style={t4}>{children}</HoverCardContent>;
    $[19] = children;
    $[20] = t4;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== onOpenChange || $[23] !== t5) {
    t6 = <HoverCard openDelay={200} closeDelay={100} onOpenChange={onOpenChange}>{t3}{t5}</HoverCard>;
    $[22] = onOpenChange;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
};
function _temp(e_0) {
  return e_0.stopPropagation();
}
function _temp2(e_1) {
  return e_1.stopPropagation();
}